import React from 'react';

import {ChatNotificationHostCodeComponent} from './ChatNotificationHostCodeComponent.jsx';

class ChatNotificationFloatingHostCodeComponent extends React.PureComponent{

	constructor(props){
		super(props);
		this.hostCodeRef = React.createRef();
		this.state = {
			top:0,
			left:0,
		};

	}

	_trackMouse(e){
		let element = this.hostCodeRef.current;
		if(!element)
		{
			return;
		}
		element = $(element);
		const width = element.width();
		const height = element.height();
		const newState = {left: e.pageX - (width / 2), top: e.pageY - (height / 2)};
		this.setState(newState);

	}

	componentDidMount(){
		this.trackMouseFunction = this._trackMouse.bind(this);
		$(document).on('mousemove', this.trackMouseFunction);
	}

	componentWillUnmount(){
		$(document).off('mousemove', this.trackMouseFunction);
	}

	render(){
		return <ChatNotificationHostCodeComponent
			top={this.state.top}
			left={this.state.left}
			isFloating={true}
			hostCodeRef={this.hostCodeRef}
			{...this.props} />
	}
}


export {ChatNotificationFloatingHostCodeComponent};